import type { PaginationResponse } from '@/types/common'
import maxios from '@/utils/axios/maxios'

// 학생 API
const studentApi = {
  // 학생 생성하기
  // [변경] POST /students — 필드명: phone→phoneNumber, parentPhone→parentPhoneNumber, homePhone→homePhoneNumber
  postVirtualStudent(data: req.CreateStudent) {
    return maxios.post('/students', data)
  },
  // 학생 생성하기
  postStudents(data: req.CreateStudent) {
    return maxios.post('/students', data)
  },
  // [변경] POST /students/xls → POST /students/excel-upload
  postStudentsXLS(data: req.StudentXLS) {
    return maxios.post<res.PostStudentXLS>('/students/excel-upload', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  // 학생 가져오기
  getStudents(pageQueryString: string, filterOptions?: req.StudentFilterOptions) {
    return maxios.get<PaginationResponse<res.Student[]>>(`/students${pageQueryString}`, {
      params: { ...filterOptions },
    })
  },
  // [변경] GET → POST /students/attendance-code
  postAttendanceCode() {
    return maxios.post<{ attendanceCode: number }>('/students/attendance-code', null)
  },
  // [변경] GET /students/{id} → GET /students/{studentId}
  getStudentDetailById(id: req.StudentId) {
    return maxios.get<res.StudentDetail>(`/students/${id}`)
  },
  // [변경] GET /students/list?idList= → POST /students/by-ids
  getStudentsById(ids: req.StudentId[]) {
    return maxios.post<res.Student[]>('/students/by-ids', {
      studentIds: ids,
    })
  },
  // [변경] GET /students/xls → GET /students/excel-template
  getStudentsXLS() {
    return maxios.get<Blob>('/students/excel-template', {
      responseType: 'blob',
    })
  },
  // [변경] PUT /students/{id} → PATCH /students/{studentId}
  patchStudentById(id: req.StudentId, data: req.ChangeStudent) {
    return maxios.patch(`/students/${id}`, data)
  },
  // [변경] PATCH /students → PATCH /students/status
  patchStudentActive(data: req.StudentPatchFilterOption) {
    return maxios.patch('/students/status', data)
  },
  patchStudentInactive(data: req.StudentPatchFilterOption) {
    return maxios.patch('/students/status', data)
  },
  // [변경] DELETE /students → DELETE /students/by-ids
  deleteStudents(data: req.StudentDeleteFilterOption) {
    return maxios({
      url: '/students/by-ids',
      method: 'DELETE',
      data,
    })
  },

  // 전체 학생 삭제 (스웨거에 없음 — 백엔드 확인 필요)
  deleteAllStudents(payload: req.StudentDeleteFilterOption) {
    return maxios.post('/students/delete-all', payload)
  },

  // 학생 목록 일괄 다운로드 (스웨거에 없음 — 백엔드 확인 필요)
  getAllStudentsListXLS(queryString: string) {
    return maxios.get<Blob>(`/students/download/xls${queryString}`, {
      responseType: 'blob',
    })
  },
  // 마지막 채점 학생 (스웨거에 없음 — 백엔드 확인 필요)
  getLastGradedStudent() {
    return maxios.get<res.LastGradedStudent>(`/students/last-graded-student`)
  },
}

export default studentApi
